import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const styles = (theme) => ({
  root: {
    position: 'absolute',
    background: theme.palette.common.grey,
    width: 640,
    top: 160,
    marginLeft: -5,
    zIndex: 200
  },
  list: {
    maxHeight: 650,
    overflow: 'scroll'
  }
});

class BuyerSearchResults extends Component {

  createResult = (item, idx) => {
    const { selected, onSelect } = this.props;
    return (
      <ListItem
        button
        onClick={onSelect(item)}
        key={item.id || item.buyeraccountid}
        selected={selected === idx}
      >
        <ListItemText primary={item.name} secondary={item.buyeraccountid} />
      </ListItem>
    )
  };

  render() {
    const { classes, results } = this.props;
    return (
      <Paper square align="center" className={classes.root}>
        {!!results && results.length > 0 && (
          <List className={classes.list}>
            {results && typeof(results) !== 'string' && results.map(this.createResult)}
          </List>
        )}
      </Paper>
    )
  }
}

BuyerSearchResults.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(BuyerSearchResults);
